interface SectionDividerProps {
  label?: string;
}

export default function SectionDivider({ label }: SectionDividerProps) {
  return (
    <div className="section-divider">
      <hr className="section-divider__line" />
      {label && <span className="section-divider__label">{label}</span>}
    </div>
  );
}
